module.exports = __webpack_public_path__ + "img/ai.a5765706.png";